import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { ShareableIncidentDataV1Response } from "@thalamos/common";

import { ukLocalFormatDateTime } from "~/util.js";

export function RenderOfficerStatus({
  officerRequest,
}: {
  officerRequest: ShareableIncidentDataV1Response;
}) {
  const { t } = useTranslation();

  const updatedAt = officerRequest.officerRequest.updatedAt;

  const statusMapping: Record<
    ShareableIncidentDataV1Response["officerRequest"]["status"],
    { body?: string }
  > = {
    requested: {
      body: t("pages.policeIncidentFormPage.statusChips.requested.body"),
    },
    accepted: {
      body: t("pages.policeIncidentFormPage.statusChips.accepted.body"),
    },
    rejected: {
      body: t("pages.policeIncidentFormPage.statusChips.rejected.body"),
    },
    notRequested: {
      body: undefined,
    },
    decisionNeeded: {
      body: undefined,
    },
  };

  const statusInfo = statusMapping[officerRequest.officerRequest.status];

  return (
    <>
      <Typography
        variant="body2"
        sx={{
          color: "common.blueGray",
          fontWeight: 600,
        }}
      >
        {t("pages.policeIncidentFormPage.lastUpdated")}
        {updatedAt
          ? ` ${ukLocalFormatDateTime(typeof updatedAt === "string" ? updatedAt : updatedAt.toISOString())}`
          : null}
      </Typography>
      {statusInfo.body && (
        <Typography
          variant="body2"
          sx={{
            color: "common.blueGray",
          }}
        >
          - {statusInfo.body}
        </Typography>
      )}
    </>
  );
}
